export const capitalize = (value, onlyFirstLetter = false) => {
  if (!value) return ''
  value = value.toString()

  if (onlyFirstLetter) {
    // Handle "a ", "ad " and "in " prefixes
    if (value.toLowerCase().startsWith('a ')) {
      return 'a ' + value.charAt(2).toUpperCase() + value.slice(3)
    }
    // "Ad Altavilla" → "ad Altavilla"; esclude gli acronimi ("AD DESIGN")
    if (value.startsWith('ad ') || value.startsWith('Ad ')) {
      return 'ad ' + value.charAt(3).toUpperCase() + value.slice(4)
    }
    if (value.toLowerCase().startsWith('in ')) {
      return 'in ' + value.charAt(3).toUpperCase() + value.slice(4)
    }
    return value.charAt(0).toUpperCase() + value.slice(1)
  }

  return value.replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substr(1))
}
